import React from 'react';

import { message , Row, Col, Button, InputNumber} from 'antd';

import { verifIsLogged, setDisconnectMachineId, getLanguage, getPays, setLanguage} from "../util/Toolbox";

import { withTranslation } from 'react-i18next';

import './css/simulateurVolume.css';
import './css/navBar.css';

import piscineRectangulaire from './assets/simulateurVolume/piscine_rectangle.png';
import piscineRonde from './assets/simulateurVolume/piscine_ronde.png';
import piscineOvale from './assets/simulateurVolume/piscine_ovale.png';
import piscineAutreForme from './assets/simulateurVolume/piscine_autre forme.png';
import piscineSchema from './assets/simulateurVolume/piscine-schema.svg';
import picto_home             from './assets/home/picto_home.png';
import home_enfant                from './assets/home/home_enfant.png';

const FORME_RECTANGULAIRE = 'RECTANGULAIRE';
const FORME_RONDE         = 'RONDE';
const FORME_OVALE         = 'OVALE';
const FORME_AUTREFORME    = 'AUTREFORME';

class SimulateurVolume extends React.Component {

  state = {
      IsShowResult : false,
      ResultatAnalyse : '',
      TypeForme : FORME_RECTANGULAIRE,
      Longueur : '',
      Largeur : '',
      ProfondeurMini : '',
      ProfondeurMaxi : '',
      Diametre : '',
      language : getLanguage(),
      languages_LIST : []
         
  }


  async componentDidMount() {


    verifIsLogged();

    let languages_LIST = getPays();
    
    this.setState({languages_LIST : languages_LIST});


    const {i18n } = this.props;
    let newLang = getLanguage();
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
    this.setState({language : newLang});

  }



      // Fonction pour changer la langue
    handleChangeLanguage = (event) => {
        const newLang = event.target.value;
        // Définir la langue  
        const {i18n } = this.props;
        console.log(newLang);
        i18n.changeLanguage(newLang);
        setLanguage(newLang);
        this.setState({language : newLang});
    };



  // Bouton simulateur
  validationSimulateur = () => {
    const { t } = this.props;

    let volume = 0;

    //Control des champs
    if(this.state.TypeForme == ''){
      message.warning(t('simul_validation_type_forme'));
      return
    }

    let profondeurMoyenne = (this.state.ProfondeurMini + this.state.ProfondeurMaxi) / 2;
    console.log('profondeurMoyenne', profondeurMoyenne);

    if(this.state.TypeForme == FORME_RONDE){
      if(!this.state.Diametre > 0){
        message.warning(t('simul_validation_diametre'));
        return;
      }
      if(!this.state.ProfondeurMini > 0){
        message.warning(t('simul_validation_profondeur_mini'));
        return;
      }
      if(!this.state.ProfondeurMaxi > 0){
        message.warning(t('simul_validation_profondeur_maxi'));
        return;
      }
      console.log('this.state.Diametre', this.state.Diametre);
      console.log('profondeurMoyenne', profondeurMoyenne);
      volume = (this.state.Diametre * this.state.Diametre * profondeurMoyenne * 0.78);
      console.log('volume', volume);
    }


    if(this.state.TypeForme == FORME_RECTANGULAIRE){
      if(!this.state.Longueur > 0){
        message.warning(t('simul_validation_longueur'));
        return;
      }
      if(!this.state.Largeur > 0){
        message.warning(t('simul_validation_largeur'));
        return;
      }
      if(!this.state.ProfondeurMini > 0){
        message.warning(t('simul_validation_profondeur_mini'));
        return;
      }
      if(!this.state.ProfondeurMaxi> 0){
        message.warning(t('simul_validation_profondeur_maxi'));
        return;
      }

      volume = this.state.Longueur * this.state.Largeur * profondeurMoyenne;
      console.log(volume);
    }


    if(this.state.TypeForme == FORME_OVALE){
      if(!this.state.Longueur > 0){
        message.warning(t('simul_validation_longueur'));
        return;
      }
      if(!this.state.Largeur > 0){
        message.warning(t('simul_validation_largeur'));
        return;
      }
      if(!this.state.ProfondeurMini > 0){
        message.warning(t('simul_validation_profondeur_mini'));
        return;
      }
      if(!this.state.ProfondeurMaxi> 0){
        message.warning(t('simul_validation_profondeur_maxi'));
        return;
      }

      volume = this.state.Longueur * this.state.Largeur * profondeurMoyenne * 0.89;
      console.log(volume);
    }


    if(this.state.TypeForme == FORME_AUTREFORME){
      if(!this.state.Longueur > 0){
        message.warning(t('simul_validation_longueur'));
        return;
      }
      if(!this.state.Largeur > 0){
        message.warning(t('simul_validation_largeur'));
        return;
      }
      if(!this.state.ProfondeurMini > 0){
        message.warning(t('simul_validation_profondeur_mini'));
        return;
      }
      if(!this.state.ProfondeurMaxi> 0){
        message.warning(t('simul_validation_profondeur_maxi'));
        return;
      }

      volume = this.state.Longueur * this.state.Largeur * profondeurMoyenne;
      console.log(volume);
    }

    this.setState({IsShowResult : true, ResultatAnalyse : volume.toFixed()})

  };


  // Bouton vers analyse
  validationToSimulateur = () => {
    window.location.href= '/forms?volume='+ this.state.ResultatAnalyse;
  };

  //Click RECTANGULAIRE
  validationRECTANGULAIRE = () => {
    this.setState({TypeForme : FORME_RECTANGULAIRE})
  };

  //Click OVALE
  validationOVALE = () => {
    this.setState({TypeForme : FORME_OVALE})
  };

  //Click RONDE
  validationRONDE = () => {
    this.setState({TypeForme : FORME_RONDE})
  };

  //Click AUTRE FORME
  validationAUTREFORME = () => {
    this.setState({TypeForme : FORME_AUTREFORME})
  };


  render() {

    const { t, i18n } = this.props; // Récupérer la traduction et le changement de langue

      return (


      <div>

        <div className = "wrapper_simulateur">

          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>

          <nav>
                  <ul>
                      <li><a href = "/"><img loading="lazy" src={picto_home} width ="180px"/></a></li>
                      <li><a style = {{marginTop : 10}} href="/forms">{t('menu_analyse')}</a></li>
                      <li><a href="/simulateur">{t('menu_calcul_volume')}</a></li>
                      <li><a href="/historique">{t('menu_historique')}</a></li>
                      <li> <span onClick={setDisconnectMachineId}> <a href="#">{t('menu_login') } </a> </span>  </li>

                      <li> 
                        <select
                          id="language-select"
                          value={this.state.language}
                          disabled = {false}
                          onChange={this.handleChangeLanguage}
                          style={{ padding: '5px', fontSize: '16px', cursor: 'pointer' }}
                        >
                          {this.state.languages_LIST.map((lang) => (
                            <option key={lang.code} value={lang.code}>
                              {lang.flag} {lang.label}
                            </option>
                          ))}
                        </select>  
                      </li>

                  </ul>
              </nav>


            <div className='containerHero'>
              <img className='imageHero'  loading="lazy" src={home_enfant}  width ="100%"/>
            </div>


        




        <div className ="containersSimulateurFormulaire">

          <p className ="CalculerVolumeTitre1">{t('simul_volTitre1')}</p>
          <p className ="CalculerVolumeTitre2">{t('simul_volTitre2')}</p>

          <p className= "CalculerVolumeTitre"><span>{t('simul_vol2Titre1')}</span>{t('simul_vol2Titre2')}</p>


          <Row gutter={[16, 0]}>
            <Col style={{ cursor: 'pointer'}} className="gutter-row" span={6} onClick= {this.validationRECTANGULAIRE}>
              <div style = {{backgroundColor: this.state.TypeForme == FORME_RECTANGULAIRE ?  '#71c5f0' : 'white'}}   className= "simulateurFormeCell">
                <img loading="lazy"  width="100" height="100" src={piscineRectangulaire} />
                <p className='button_simulateur'>{t('simul_Forme_Rectangle')}</p>
              </div>
            </Col>
            <Col style={{ cursor: 'pointer'}} className="gutter-row" span={6} onClick= {this.validationOVALE}>
              <div style = {{backgroundColor: this.state.TypeForme == FORME_OVALE ?  '#71c5f0' : 'white'}} className= "simulateurFormeCell">
                <img loading="lazy" width="100" height="100"  src={piscineOvale} />
                <p className='button_simulateur'>{t('simul_Forme_Oval')}</p>
              </div>
            </Col>
            <Col style={{ cursor: 'pointer'}} className="gutter-row" span={6} onClick= {this.validationRONDE}>
              <div style = {{backgroundColor: this.state.TypeForme == FORME_RONDE ?  '#71c5f0' : 'white'}} className= "simulateurFormeCell">
                <img loading="lazy" width="100" height="100" src={piscineRonde} />
                <p className='button_simulateur'>{t('simul_Forme_Ronde')}</p>
              </div>
            </Col>
            <Col style={{ cursor: 'pointer'}} className="gutter-row" span={6} onClick= {this.validationAUTREFORME}>
              <div style = {{backgroundColor: this.state.TypeForme == FORME_AUTREFORME?  '#71c5f0' : 'white'}} className= "simulateurFormeCell">
                <img loading="lazy"  width="100" height="100"  src={piscineAutreForme} />
                <p className='button_simulateur'>{t('simul_Forme_Autre')}</p>
              </div>
            </Col>
          </Row>


          <p className= "CalculerVolumeTitre"><span>{t('simul_vol3Titre1')}</span>{t('simul_vol3Titre2')}</p>

          <div className = "dimension_bassin">

            <Row  gutter={[16, 16]}>

              {
                this.state.TypeForme != FORME_RONDE
                &&
                (
                  <Col sm={12} xs={12}>
                    <p>{t('simul_Longueur')}</p>
                    <InputNumber style = {{width:'80%', marginTop : -5}} value = {this.state.Longueur} onChange={(event) => this.setState({Longueur: event})}  className = "input_calculVolume" placeholder="" step={0.1} precision={1} />
                  </Col>
                )
              }

              {
                this.state.TypeForme != FORME_RONDE
                &&
                (
                  <Col sm={12} xs={12}  >
                    <p>{t('simul_Largeur')}</p>
                    <InputNumber style = {{width:'80%', marginTop : -5}} value = {this.state.Largeur} onChange={(event) => this.setState({Largeur: event})} className = "input_calculVolume" placeholder="" step={0.1} precision={1} />
                  </Col>
                )
              }

              {
                this.state.TypeForme == FORME_RONDE
                &&
                (
                  <Col sm={12} xs={12}  >
                    <p>{t('simul_Diametre')}</p>
                    <InputNumber style = {{width:'80%', marginTop : -5}} value = {this.state.Diametre } onChange={(event) => this.setState({Diametre: event})} className = "input_calculVolume" placeholder="" step={0.1} precision={1} />
                  </Col>
                )
              }


                  <Col sm={12} xs={12}>
                    <p>{t('simul_ProfondeurMini')}</p>
                    <InputNumber style = {{width:'80%', marginTop : -5}} value = {this.state.ProfondeurMini} onChange={(event) => this.setState({ProfondeurMini: event})}  className = "input_calculVolume" placeholder="" step={0.1} precision={1} />
                  </Col>


              <Col sm={12} xs={12} >
                <p>{t('simul_ProfondeurMaxi')}</p>
                <InputNumber style = {{width:'80%', marginTop : -5}} value = {this.state.ProfondeurMaxi}  onChange={(event) => this.setState({ProfondeurMaxi: event})} className = "input_calculVolume" placeholder="" step={0.1} precision={1} />
              </Col>

             

            </Row>

            {
                this.state.IsShowResult == true &&
                (
                  <div style = {{marginBottom:30}} className = "result_simulateur">

                    <p className= "titre1">{t('simul_resultat_volume')}</p>
                    <p className= "titre2">{this.state.ResultatAnalyse + " m³"}</p>

                    <div className = "">
                      <Button className = 'buttonFormStyle'  onClick={this.validationToSimulateur} size={"large"} style={{borderRadius : 20,fontWeight:600, paddingLeft:40, paddingRight:40, marginBottom: 16, borderColor: '#2B4570', backgroundColor: '#2B4570', color:'#FFFFFF'}}>{t('simul_Button')}</Button>
                    </div>

                  </div>
                )
            }

            {
              this.state.IsShowResult == false &&
              (
                <div className= "image_schema">
                  <img loading="lazy" src={piscineSchema} />
                </div>
              )
            }


            <div style = {{display:'none'}} className= "image_schema">
              <img loading="lazy" src={piscineAutreForme} />
            </div>

            {
              this.state.IsShowResult == false &&
              <div style = {{marginTop:10}}>
                <Button className = 'buttonFormStyle'  onClick={this.validationSimulateur} size={"large"} style={{borderRadius : 20,fontWeight:600, paddingLeft:40, paddingRight:40, marginBottom: 30,  borderColor: '#2B4570', backgroundColor: '#2B4570', color:'#FFFFFF'}}>{t('simul_Button2')}</Button>
              </div>
            }


            <div style = {{color:'white', marginTop:200}}>
              <p>fin</p>
            </div>


          </div>

        </div>

      </div>

     

      </div>
      )

    };
}





export default withTranslation() (SimulateurVolume);
